// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2Jrlf","file":"styles_file__3UCWw"};